import type { SVGProps } from 'react';
const SvgIconInquire = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={27} height={26} {...props}>
    <path
      fill="#1A202C"
      d="M5.055 13.148c-.795.453-.721 1.663.127 2.014l4.935 2.057v3.631a1.148 1.148 0 0 0 2.034.735l2.18-2.612 4.36 1.814a1.136 1.136 0 0 0 1.544-.868l2.252-14.625a1.12 1.12 0 0 0-.475-1.097 1.13 1.13 0 0 0-1.196-.05zm1.833.896 12.014-6.859-7.726 8.628.043.035zm11.789 4.911-5.861-2.443L20.348 8.1l-1.671 10.856z"
    />
  </svg>
);
export default SvgIconInquire;
